import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { collectionApi } from '../api';
import { collectionKeys } from './collection.keys';

// Mutação de remoção
export function useDeleteCollection(
  options?: UseMutationOptions<{ id: string; deletedAt: string }, Error, string>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['collections', 'delete'],
    mutationFn: collectionApi.remove,
    ...mutationOptions,
    onSuccess: (response, variables, onMutateResult, context) => {
      toast({
        title: 'Coleção excluída com sucesso',
        variant: 'success',
      });
      queryClient.invalidateQueries({ queryKey: collectionKeys.all });
      providedOnSuccess?.(response, variables, onMutateResult, context);
    },
    onError: (error, variables, onMutateResult, context) => {
      toast({
        title: 'Erro ao excluir coleção',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, onMutateResult, context);
    },
  });
  const deleteCollection = (collectionId: string) => mutation.mutateAsync(collectionId);
  return {
    deleteCollection,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
